module.exports = __webpack_public_path__ + "static/media/3.3bf93080.jpg";